module.exports = __webpack_public_path__ + "img/makerspace-white.b8afb6e2.png";